<script setup lang="ts">
  import { toRefs } from 'vue'
  import { useI18n } from 'vue-i18n'
  import {
    MagnifyingGlassIcon,
    CheckBadgeIcon,
    DevicePhoneMobileIcon,
    CubeIcon,
    ChartBarIcon,
    NewspaperIcon,
    VideoCameraIcon,
    CameraIcon
  } from '@heroicons/vue/24/outline'

  const { t } = useI18n({ useScope: 'global' })
  const props = defineProps({
    initialQuery: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    }
  })

  const { initialQuery, type } = toRefs(props)

  const emit = defineEmits<{
    (e: 'submit', query: string): void
  }>()

  function onQueryChange(ev: Event) {
    const query = (ev.target as HTMLInputElement).value
    emit('submit', query)
  }

  function onQueryFocus(ev: Event) {
    const el = ev.target as HTMLInputElement
    el.setSelectionRange(el.value.length, el.value.length)
  }
</script>

<template>
  <label class="input">
    <CameraIcon
      v-if="type == 'picture'"
      class="size-6"
    />
    <VideoCameraIcon
      v-else-if="type == 'video'"
      class="size-6"
    />
    <NewspaperIcon
      v-else-if="type == 'multimedia'"
      class="size-6"
    />
    <ChartBarIcon
      v-else-if="type == 'graphic'"
      class="size-6"
    />
    <CubeIcon
      v-else-if="type == 'videography'"
      class="size-6"
    />
    <DevicePhoneMobileIcon
      v-else-if="type == 'webstory'"
      class="size-6"
    />
    <CheckBadgeIcon
      v-else-if="type == 'factcheck'"
      class="size-6"
    />
    <MagnifyingGlassIcon
      v-else
      class="size-6"
    />
    <input
      ref="search"
      :placeholder="t('column.search')"
      :aria-label="t('column.search')"
      :value="initialQuery"
      autocomplete="off"
      name="query"
      type="search"
      @change="onQueryChange"
      @search="onQueryChange"
      @focus="onQueryFocus"
      @keydown.enter.prevent="onQueryChange"
    />
  </label>
</template>
